<h2 mat-dialog-title>Hola{{ data.title }}</h2>
<mat-dialog-content class="mat-typography">
  <ngx-json-viewer [json]="data.json" [expanded]="false"></ngx-json-viewer>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button tabindex="-1" mat-stroked-button color="warn" (click)="onClose()">
    <mat-icon>cancel</mat-icon>
    Cerrar
  </button>
  <button tabindex="-1" mat-flat-button color="accent" (click)="onDownload()">
    <mat-icon>download</mat-icon>
    Descargar JSON
  </button>
</mat-dialog-actions>